import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import Table from 'react-bootstrap/Table';
import { getItemTypeList, getUrnsList, getAllRouteDetails, getRateUnits } from './rateCardAPIs';
import { getAllState, getAllDistrict, getAllRevenueCircle, getCategoryList } from '../resourceCommonAPIs';
import { CATEGORY_ERROR, ITEM_TYPE_ERROR, STATE_ERROR, DISTRICT_ERROR, REVENUE_CIRCLE_ERROR, ROUTE_TYPE_ERROR, UNIT_PER_ERROR, CREATE_RATE_CARD, STAKEHOLDER_URN, STAKEHOLDER_NAME, REGISTRATION_NO, VEHICLE_TYPE, VEHICLE_CAPACITY, VEHICLE_MAKE, VEHICLE_MODEL, ROUTE, LAND_NAME, ITEM_RATE, SUBMIT, CATEGORY, ITEM_TYPE, ROUTE_TYPE, STATE, DISTRICT, REVENUE_CIRCLE, UNIT_PER, ITEM_RATE_MASS_ENTRY, INSERT_SELECTED, NO_DATA_AVAILABLE, PROCEED, allowedFileTypes, FILE_NAME_VALIDATION_ERROR } from '../../../common/constants';
import { handleNumberFieldFocus, titleCase } from '../../../common/commonFunction';
import { Button, CardContent } from '@mui/material';
import { ErrorPopover } from "../../../common/ErrorPopover/errorPopover";
import { PROD } from '../../../common/constants';
import { Container, Card, Stack, Box, Typography, Grid, FormHelperText, FormControl, InputLabel, Select, MenuItem, TextField } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { DataGrid } from '@mui/x-data-grid';
import CustomDataGridToolbar from '../../../common/customDataGridToolbar';
import BackButton from '../../../common/backButton';
import { DistrictChangePopover } from './districtChangePopover';
import { loaderService } from "../../../common/custom-loader/loader-service";
import { capitalizeFunction, fileNameValidation, openTextFieldMaxLength, validateAmount, VALIDATION } from '../../../common/commonValidations';
import { v4 as uuidv4 } from 'uuid';
import { toast } from 'react-toastify';
import { ConfirmationPopover } from "../../../common/commonPopovers/confirmationPopover";

import { ADD_RATE_CONFIRMATION, authKey, CHECK_RATE_CARD_VALIDITY_STAKEHOLDER, UPLOAD_DCUMENT } from "../../../common/URLs";
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import Badge from 'react-bootstrap/Badge';
import { ProceedIcon, SubmitIcon } from "../../../common/icons";
import apiClient from "../../../axios";
import { useTranslation } from "react-i18next";
import TrashIcon from '../../../images/TrashIcon.png';


function CreateAndSendRatesToStakeholders() {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [selectedRows, setSelectedRows] = useState([]);
    const [characterLimit] = useState(1000);
    const { state } = useLocation();
    const [showData, setShowData] = useState(state?.category ? true : false);
    const [onChangeFlag, setOnChangeFlag] = useState(false);
    const [urnsList, setUrnsList] = useState(state?.urnsList && state?.urnsList);
    const [chooseState, setchooseState] = useState([]);
    const [chooseDistrict, setChooseDistrict] = useState([]);
    const [chooseRevenueCircle, setChooseRevenueCircle] = useState([]);
    const [unitsList, setUnitsList] = useState([]);
    const [checkValidityResponse, setCheckValidityResponse] = useState();
    const [comment, setComment] = useState("");
    const [commentError, setCommentError] = useState("");
    // const [documentsArray, setDocumentsArray] = useState([]);
    const [failedRateCardArr, setFailedRateCardArr] = useState();
    const [logModalOpen, setLogModalOpen] = useState(false);
    const handleLogModalOpen = () => setLogModalOpen(true);
    const handleLogModalClose = () => setLogModalOpen(false);
    const [distrcitLogModalOpen, setDistrcitLogModalOpen] = useState(false);
    const handleDistrictLogModalOpen = () => setDistrcitLogModalOpen(true);
    const handleDistrictLogModalClose = () => setDistrcitLogModalOpen(false);
    const [rateCardDetails, setRateCardDetails] = useState(
        {
            category: state?.category ? state?.category : "Grower",
            itemType: state?.itemType ? state?.itemType : "Bamboo Rate",
            unitPer: state?.unitPer ? state?.unitPer : null,
            // validFromProceed: state?.validFromProceed ? state?.validFromProceed : "2024-07-26",
            // validToProceed: state?.validToProceed ? state?.validToProceed : "2024-07-27",
            validFrom: state?.validFrom ? state?.validFrom : null,
            validTo: state?.validTo ? state?.validTo : null,
            expiredDate: state?.expiredDate ? state?.expiredDate : null,
            itemRate: state?.itemRate ? state?.itemRate : null,
            routeType: state?.routeType ? state?.routeType : null,
            state: state?.state ? state?.state : null,
            district: state?.district ? state?.district : null,
            revenueCircle: state?.revenueCircle ? state?.revenueCircle : null,
        }
    );
    const [errorMessage, setErrorMessage] = useState({
        categoryError: '',
        itemTypeError: '',
        unitPerError: '',
        itemRateError: '',
        validFromError: '',
        validToError: '',
        expiredDateError: '',
        // validFromProceedError: '',
        // validToProceedError: '',
        routeTypeError: '',
        stateError: '',
        districtError: '',
        addItemError: '',
        documentError: '',
    });
    const [rateCardDetailsArr, setRateCardDetailsArr] = useState(state?.rateCardDetailsArr ? state?.rateCardDetailsArr : []);
    const [finalRateCardDetailsArr, setFinalRateCardDetailsArr] = useState(state?.finalRateCardDetailsArr && state?.finalRateCardDetailsArr);
    const [addedRateCardDetailsArr, setAddedRateCardDetailsArr] = useState(state?.addedRateCardDetailsArr ? state?.addedRateCardDetailsArr : []);
    const [filteredRateCardDetailsArr, setFilteredRateCardDetailsArr] = useState();
    const [filterTable, setFilterTable] = useState({
        urnNumber: '',
        stakeholderName: ''
    });
    const [submit, setSubmit] = useState(false);
    const [documentUploadDetails, setDocumentUploadDetails] = useState();
    const [documentsArr, setDocumentsArr] = useState([]);
    const [selectedFile, setSelectedFile] = useState();
    const [fileuploadError, setFileuploadError] = useState('');
    const [isApiCalled, setIsApiCalled] = useState(false);

    useEffect(() => {
        getAllState(setchooseState);
        getRateUnits(setUnitsList);
    }, []);

    useEffect(() => {
        if (urnsList && onChangeFlag) {
            let arrayData = []
            urnsList?.map((item) => {
                if (rateCardDetails?.category === "Grower" && rateCardDetails?.itemType === "Bamboo Rate") {
                    item?.landDtlList?.map((landDtlList) => arrayData.push({
                        id: uuidv4(),
                        category: rateCardDetails?.category,
                        growerType: item?.category,
                        itemType: rateCardDetails?.itemType,
                        unitPer: rateCardDetails?.unitPer,
                        urnNumber: item?.urn,
                        totalQuantity: item?.totalQuantity,
                        committedQuantity: item?.committedQuantity,
                        growerDbs: landDtlList?.growerDbs,
                        stakeholderName: item?.name,
                        state: landDtlList?.state,
                        district: landDtlList?.district,
                        revenueCircle: landDtlList?.revenueCircle,
                        vehicleId: null,
                        registrationNo: null,
                        vehicleType: null,
                        vehicleCapacity: null,
                        vehicleMake: null,
                        vehicleModel: null,
                        vehicleMakeModel: null,
                        routeName: null,
                        transporterTableId: null,
                        route: null,
                        routeUrn: null,
                        landId: landDtlList?.landId,
                        landName: landDtlList?.landName,
                        landType: landDtlList?.landType,
                        itemRate: null,
                        validFrom: null,
                        validTo: null,
                        expiredDate: null,
                        background: null,
                        justification: null,
                        finalSummary: null,
                        documentName: null,
                        documentGuid: null,
                        stakeholderEmail: item?.emailId,
                        stakeholderMobile: item?.mobile
                    }))
                }
            }
            )
            setRateCardDetailsArr(arrayData);
        }
    }, [urnsList]);

    const onProceedViewRateCardTable = () => {
        if (!rateCardDetails?.state) {
            setErrorMessage({ ...errorMessage, stateError: STATE_ERROR });
        }
        else if (!rateCardDetails?.district) {
            setErrorMessage({ ...errorMessage, districtError: DISTRICT_ERROR });
        }
        else {
            getUrnsList(setUrnsList, rateCardDetails);
            setShowData(true);
        }
    }

    const onInsertItemRate = (e) => {
        setRateCardDetailsArr((prevRows) => prevRows?.map(rateCardDetailsArrItem => selectedRows?.includes(rateCardDetailsArrItem?.id) ? {
            ...rateCardDetailsArrItem,
            itemRate: rateCardDetails?.itemRate,
            validFrom: rateCardDetails?.validFrom,
            validTo: rateCardDetails?.validTo,
            expiredDate: rateCardDetails?.expiredDate,
        } : rateCardDetailsArrItem))
        setFailedRateCardArr();
    }

    const handleEachChange = (e, item, type) => {
        setOnChangeFlag(true);
        const tempArr = ((rateCardDetailsArr).map(rateCardDetailsArrItem => {
            if (rateCardDetailsArrItem.urnNumber === item.urnNumber && rateCardDetailsArrItem.vehicleId === item.vehicleId && rateCardDetailsArrItem.transporterTableId === item.transporterTableId && rateCardDetailsArrItem.landId === item.landId) {
                if (type === "itemRateEach") {
                    const validatedAmount = validateAmount(e.target.value);
                    if (e.target.value === '') {
                        rateCardDetailsArrItem.itemRate = ''
                    }
                    if (validatedAmount) {
                        rateCardDetailsArrItem.itemRate = validatedAmount
                    }
                }
                if (type === "validFromEach") {
                    const tempArr = failedRateCardArr && failedRateCardArr?.filter(filterItem => filterItem !== item)
                    setFailedRateCardArr(tempArr);
                    rateCardDetailsArrItem.validFrom = e.format("YYYY-MM-DD")
                }
                if (type === "validToEach") {
                    const tempArr = failedRateCardArr && failedRateCardArr?.filter(filterItem => filterItem !== item)
                    setFailedRateCardArr(tempArr);
                    rateCardDetailsArrItem.validTo = e.format("YYYY-MM-DD")
                }
                if (type === "expiredDate") {
                    const tempArr = failedRateCardArr && failedRateCardArr?.filter(filterItem => filterItem !== item)
                    setFailedRateCardArr(tempArr);
                    rateCardDetailsArrItem.expiredDate = e.format("YYYY-MM-DD")
                }
            }
            return rateCardDetailsArrItem
        }
        ))
        setRateCardDetailsArr(tempArr);
    }

    const [tempDistrict, setTempDistrict] = useState("")

    const handleChange = (e, item) => {
        setOnChangeFlag(true);
        if (e.target.name === "category") {
            setRateCardDetails({ ...rateCardDetails, category: e.target.value })
            setErrorMessage({ ...errorMessage, categoryError: "" });
        }
        if (e.target.name === "itemType") {
            setRateCardDetails({ ...rateCardDetails, itemType: e.target.value })
            setErrorMessage({ ...errorMessage, itemTypeError: "" });
        }
        if (e.target.name === "state") {
            getAllDistrict(e.target.value, setChooseDistrict);
            setRateCardDetails({ ...rateCardDetails, state: e.target.value })
            setErrorMessage({ ...errorMessage, stateError: "" });
        }
        if (e.target.name === "district") {
            setTempDistrict(e.target.value)
            if (addedRateCardDetailsArr.length !== 0) {
                handleDistrictLogModalOpen();
            }
            else {
                getAllRevenueCircle(e.target.value, setChooseRevenueCircle);
                setRateCardDetails({ ...rateCardDetails, district: e.target.value })
                setErrorMessage({ ...errorMessage, districtError: "" });
            }
        }
        if (e.target.name === "revenueCircle") {
            setRateCardDetails({ ...rateCardDetails, revenueCircle: e.target.value })
        }
        // if (e.target.name === "validFromProceed") {
        //     if(rateCardDetails.validToProceed < e.target.value) {
        //       setErrorMessage({ ...errorMessage, validFromProceedError: "Valid from date cannot be more than valid from date" });
        //     }
        //     else {
        //     setErrorMessage({ ...errorMessage, validFromProceedError: "" });
        //     }
        //     setRateCardDetails({ ...rateCardDetails, validFromProceed: e.target.value })
        // }
        // if (e.target.name === "validToProceed") {
        //     if(rateCardDetails.validFromProceed > e.target.value) {
        //       setErrorMessage({ ...errorMessage, validToProceedError: "Valid to date cannot be less than valid from date" });
        //     }
        //     else {
        //     setErrorMessage({ ...errorMessage, validToProceedError: "" });
        //     }
        //     setRateCardDetails({ ...rateCardDetails, validToProceed: e.target.value })
        // }
        if (e.target.name === "routeType") {
            setRateCardDetails({ ...rateCardDetails, routeType: e.target.value })
            setErrorMessage({ ...errorMessage, routeTypeError: "" });
        }
        if (e.target.name === "unitPer") {
            setRateCardDetails({ ...rateCardDetails, unitPer: e.target.value })
            setErrorMessage({ ...errorMessage, unitPerError: "" });
        }
        if (e.target.name === "itemRate") {
            const validatedAmount = validateAmount(e.target.value);
            if (e.target.value === '') {
                setRateCardDetails({ ...rateCardDetails, itemRate: '' })
            }
            if (validatedAmount) {
                setRateCardDetails({ ...rateCardDetails, itemRate: validatedAmount })
            }
        }
        if (e.target.name === "validFrom") {
            setRateCardDetails({ ...rateCardDetails, validFrom: e.target.value })
        }
        if (e.target.name === "validTo") {
            setRateCardDetails({ ...rateCardDetails, validTo: e.target.value })
        }
        if (e.target.name === "expiredDate") {
            setRateCardDetails({ ...rateCardDetails, expiredDate: e.target.value })
        }
        if (item) {
            const tempArr = ((rateCardDetailsArr).map(rateCardDetailsArrItem => {
                if (rateCardDetailsArrItem.urnNumber === item.urnNumber && rateCardDetailsArrItem.vehicleId === item.vehicleId && rateCardDetailsArrItem.transporterTableId === item.transporterTableId && rateCardDetailsArrItem.landId === item.landId) {
                    if (e.target.name === "itemRateEach") {
                        rateCardDetailsArrItem.itemRate = e.target.value
                    }
                    if (e.target.name === "validFromEach") {
                        const tempArr = failedRateCardArr && failedRateCardArr?.filter(filterItem => filterItem !== item)
                        setFailedRateCardArr(tempArr);
                        rateCardDetailsArrItem.validFrom = e.target.value
                    }
                    if (e.target.name === "validToEach") {
                        const tempArr = failedRateCardArr && failedRateCardArr?.filter(filterItem => filterItem !== item)
                        setFailedRateCardArr(tempArr);
                        rateCardDetailsArrItem.validTo = e.target.value
                    }
                    if (e.target.name === "expiredDate") {
                        const tempArr = failedRateCardArr && failedRateCardArr?.filter(filterItem => filterItem !== item)
                        setFailedRateCardArr(tempArr);
                        rateCardDetailsArrItem.expiredDate = e.target.value
                    }
                }
                return rateCardDetailsArrItem
            }
            ))
            setRateCardDetailsArr(tempArr);
        }
    }

    useEffect(() => {
        if (onChangeFlag) {
            let arrayData = [];
            rateCardDetailsArr?.map((item) =>
                item.itemRate && arrayData.push(item)
            )
            setFinalRateCardDetailsArr(arrayData);
        }
    }, [rateCardDetailsArr]);

    useEffect(() => {
        if (onChangeFlag) {
            setRateCardDetails({
                ...rateCardDetails,
                itemType: null,
                itemRate: null,
                // validFromProceed: null,
                // validToProceed: null,
                validFrom: null,
                validTo: null,
                expiredDate: null,
                unitPer: null,
                routeType: null,
                state: null,
                district: null,
                revenueCircle: null
            });
            setRateCardDetailsArr([]);
            setShowData(false);
            setUrnsList();
            setChooseDistrict([]);
        }
    }, [rateCardDetails.category]);

    useEffect(() => {
        if (onChangeFlag) {
            setRateCardDetails({
                ...rateCardDetails,
                itemRate: null,
                validFrom: null,
                validTo: null,
                expiredDate: null,
            });
            setRateCardDetailsArr([]);
            setShowData(false);
            setUrnsList();
        }
    }, [rateCardDetails.itemType, rateCardDetails.routeType, rateCardDetails.revenueCircle]);

    useEffect(() => {
        if (onChangeFlag) {
            setRateCardDetails({
                ...rateCardDetails,
                itemRate: null,
                validFrom: null,
                validTo: null,
                expiredDate: null,
                district: null,
                revenueCircle: null
            });
            setShowData(false);
            setUrnsList();
        }
    }, [rateCardDetails.state]);

    useEffect(() => {
        if (onChangeFlag) {
            setRateCardDetails({
                ...rateCardDetails,
                itemRate: null,
                validFrom: null,
                validTo: null,
                expiredDate: null,
                revenueCircle: null
            });
            setShowData(false);
            setUrnsList();
        }
    }, [rateCardDetails.district]);

    useEffect(() => {
        if (onChangeFlag) {
            const tempArr = (rateCardDetailsArr?.map(item => {
                if (!addedRateCardDetailsArr?.includes(item)) {
                    item.unitPer = rateCardDetails.unitPer
                }
                return item
            }
            ))
        }
    }, [rateCardDetails?.unitPer]);
    useEffect(() => {
        if (filterTable.urnNumber || filterTable.stakeholderName) {
            const filteredRateCardDetails = rateCardDetailsArr && rateCardDetailsArr?.filter(
                item => {
                    let keep = true;
                    if (filterTable.urnNumber) {
                        keep = keep && item.urnNumber?.toLowerCase()?.includes(filterTable?.urnNumber.toLowerCase().trim())
                    }
                    if (filterTable.stakeholderName) {
                        keep = keep && item.stakeholderName?.toLowerCase()?.includes(filterTable?.stakeholderName.toLowerCase().trim())
                    }
                    return keep;
                }

            );
            setFilteredRateCardDetailsArr(filteredRateCardDetails);
        }
        else {
            setFilteredRateCardDetailsArr();
        }
    }, [filterTable.urnNumber, filterTable.stakeholderName]);

    useEffect(() => {
        if (checkValidityResponse) {
            const successTempArr = [];
            const failTempArr = [];
            checkValidityResponse?.map((item) => {
                if (item?.abrplRespStts?.status === "SUCCESS") {
                    const pushObject = finalRateCardDetailsArr.find(findItem => findItem?.urnNumber === item?.rateConfirmationEntity?.urnNumber && findItem?.landId === item?.rateConfirmationEntity?.landId);
                    successTempArr.push(pushObject);
                }
                else {
                    const pushObject = finalRateCardDetailsArr.find(findItem => findItem?.urnNumber === item?.rateConfirmationEntity?.urnNumber && findItem?.landId === item?.rateConfirmationEntity?.landId);
                    failTempArr.push(pushObject);
                }
            });
            setErrorMessage({ ...errorMessage, addItemError: "" });
            setAddedRateCardDetailsArr([...addedRateCardDetailsArr, ...successTempArr]);
            setFailedRateCardArr(failTempArr);
            if (!checkValidityResponse?.every(item => item?.abrplRespStts?.status === "SUCCESS")) {
                toast.error("Rate card already exists in the given date range for the items marked in red")
            }
            if (successTempArr?.length > 0) {
                handleLogModalOpen();
            }
            // else {
            //     handleLogModalOpen();
            // }
        }
    }, [checkValidityResponse]);

    function onCancelBack() {
        handleDistrictLogModalClose();
    }

    function onConfirmCallBack() {
        handleDistrictLogModalClose();
        getAllRevenueCircle(tempDistrict, setChooseRevenueCircle);
        setRateCardDetails({ ...rateCardDetails, district: tempDistrict })
        setErrorMessage({ ...errorMessage, districtError: "" });
        setAddedRateCardDetailsArr([]);
        setFinalRateCardDetailsArr([]);
    }

    const excelColumns = [
        { field: 'category', headerName: "Category", width: 150 },
        { field: 'itemType', headerName: "Item Type", width: 150 },
        { field: 'urnNumber', headerName: STAKEHOLDER_URN, width: 500 },
        { field: 'growerDbs', headerName: "DBS Grower", width: 100 },
        { field: 'stakeholderName', headerName: STAKEHOLDER_NAME, width: 150 },
        { field: 'unitPer', headerName: "Unit Per", width: 150 },
        { field: 'registrationNo', headerName: REGISTRATION_NO, width: 150, hide: !(rateCardDetails?.category === "HIT" && rateCardDetails?.itemType === "Transportation Rate") },
        { field: 'vehicleType', headerName: VEHICLE_TYPE, width: 150, hide: !(rateCardDetails?.category === "HIT" && rateCardDetails?.itemType === "Transportation Rate") },
        { field: 'vehicleCapacity', type: "number", headerName: VEHICLE_CAPACITY, width: 150, hide: !(rateCardDetails?.category === "HIT" && rateCardDetails?.itemType === "Transportation Rate") },
        { field: 'vehicleMake', headerName: VEHICLE_MAKE, width: 150, hide: !(rateCardDetails?.category === "HIT" && rateCardDetails?.itemType === "Transportation Rate") },
        { field: 'vehicleModel', headerName: VEHICLE_MODEL, width: 150, hide: !(rateCardDetails?.category === "HIT" && rateCardDetails?.itemType === "Transportation Rate") },
        { field: 'vehicleId', headerName: "Vehicle Id", width: 150, hide: !(rateCardDetails?.category === "HIT" && rateCardDetails?.itemType === "Transportation Rate") },
        {
            field: 'state', headerName: STATE, width: 150, hide: rateCardDetails?.category !== "LLE" && rateCardDetails?.category !== "Grower",
            renderCell: (params) => {
                return (
                    params?.row?.state && titleCase(params?.row?.state)
                )
            }
        },
        {
            field: 'district', headerName: DISTRICT, width: 150, hide: rateCardDetails?.category !== "LLE" && rateCardDetails?.category !== "Grower",
            renderCell: (params) => {
                return (
                    params?.row?.district && titleCase(params?.row?.district)
                )
            }
        },
        {
            field: 'revenueCircle', headerName: REVENUE_CIRCLE, width: 150, hide: rateCardDetails?.category !== "Grower",
            renderCell: (params) => {
                return (
                    params?.row?.district && titleCase(params?.row?.district)
                )
            }
        },
        { field: 'route', headerName: ROUTE, width: 150, hide: !(rateCardDetails?.category === "Transporter" && rateCardDetails?.itemType === "Transportation Rate") },
        { field: 'routeName', headerName: "Route Name", width: 150, hide: !(rateCardDetails?.category === "Transporter" && rateCardDetails?.itemType === "Transportation Rate") },
        { field: 'transporterTableId', headerName: "Transport Id", width: 150, hide: !(rateCardDetails?.category === "Transporter" && rateCardDetails?.itemType === "Transportation Rate") },
        { field: 'totalQuantity', headerName: "Total Qty(in MT)", width: 180 },
        { field: 'committedQuantity', headerName: "Committed Qty(in MT)", width: 180 },
        { field: 'landName', headerName: LAND_NAME, width: 150, hide: !(rateCardDetails?.category === "Grower" && rateCardDetails?.itemType === "Bamboo Rate") },
        { field: 'landId', headerName: "Land Id", width: 150, hide: !(rateCardDetails?.category === "Grower" && rateCardDetails?.itemType === "Bamboo Rate") },
        {
            field: 'validFrom', headerName: 'Valid From', width: 170,
            renderCell: (params) => {
                return (
                    <>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DesktopDatePicker
                                label="Valid From"
                                inputFormat="DD/MM/YYYY"
                                value={params.row?.validFrom}
                                onChange={(newValue) => handleEachChange(newValue, params.row, "validFromEach")}
                                renderInput={(params) => <TextField {...params}
                                    size="small" />}
                                sx={{ minWidth: 750 }}
                            /></LocalizationProvider>
                    </>
                )
            }
        },
        {
            field: 'validTo', headerName: 'Valid To', width: 170,
            renderCell: (params) => {
                return (
                    <>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DesktopDatePicker
                                label="Valid To"
                                inputFormat="DD/MM/YYYY"
                                minDate={params.row?.validFrom}
                                value={params?.row?.validTo}
                                onChange={(newValue) => handleEachChange(newValue, params.row, "validToEach")}
                                renderInput={(params) => <TextField {...params}
                                    size="small" />}
                                sx={{ minWidth: 750 }}
                            /></LocalizationProvider>
                    </>
                )
            }
        },
        {
            field: 'expiredDate', headerName: 'Expiry Date', width: 170,
            renderCell: (params) => {
                return (
                    <>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DesktopDatePicker
                                label="Expiry Date"
                                inputFormat="DD/MM/YYYY"
                                value={params.row?.expiredDate}
                                onChange={(newValue) => handleEachChange(newValue, params.row, "expiredDate")}
                                renderInput={(params) => <TextField {...params}
                                    size="small" />}
                                sx={{ minWidth: 750 }}
                            /></LocalizationProvider>
                    </>
                )
            }
        },
        {
            field: 'itemRate', headerName: ITEM_RATE, width: 150,
            renderCell: (params) => {
                return (
                    <TextField fullWidth
                        size="small"
                        label="Item Rate"
                        type="number"
                        onFocus={handleNumberFieldFocus}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '-' || evt.key === '+') && evt.preventDefault()}
                        value={params.row?.itemRate || ''}
                        onChange={(e) => handleEachChange(e, params.row, "itemRateEach")}
                    ></TextField>
                )
            }
        },
        { field: 'background', headerName: "Background", width: 150 },
        { field: 'justification', headerName: "Justification", width: 150 },
        { field: 'finalSummary', headerName: "Final Summary", width: 150 },
    ];

    const columns = [
        { field: 'urnNumber', headerName: STAKEHOLDER_URN, width: 150 },
        { field: 'stakeholderName', headerName: STAKEHOLDER_NAME, width: 150 },
        { field: 'growerDbs', headerName: "DBS Grower", width: 100 },
        { field: 'registrationNo', headerName: REGISTRATION_NO, width: 150, hide: !(rateCardDetails?.category === "HIT" && rateCardDetails?.itemType === "Transportation Rate") },
        { field: 'vehicleType', headerName: VEHICLE_TYPE, width: 150, hide: !(rateCardDetails?.category === "HIT" && rateCardDetails?.itemType === "Transportation Rate") },
        { field: 'vehicleCapacity', headerName: VEHICLE_CAPACITY, width: 150, hide: !(rateCardDetails?.category === "HIT" && rateCardDetails?.itemType === "Transportation Rate") },
        { field: 'vehicleMake', headerName: VEHICLE_MAKE, width: 150, hide: !(rateCardDetails?.category === "HIT" && rateCardDetails?.itemType === "Transportation Rate") },
        { field: 'vehicleModel', headerName: VEHICLE_MODEL, width: 150, hide: !(rateCardDetails?.category === "HIT" && rateCardDetails?.itemType === "Transportation Rate") },
        {
            field: 'state', headerName: STATE, width: 150, hide: rateCardDetails?.category !== "LLE",
            renderCell: (params) => {
                return (
                    params?.row?.state && titleCase(params?.row?.state)
                )
            }
        },
        {
            field: 'district', headerName: DISTRICT, width: 150, hide: rateCardDetails?.category !== "LLE",
            renderCell: (params) => {
                return (
                    params?.row?.district && titleCase(params?.row?.district)
                )
            }
        },
        { field: 'route', headerName: ROUTE, width: 150, hide: !(rateCardDetails?.category === "Transporter" && rateCardDetails?.itemType === "Transportation Rate") },
        { field: "routeUrn", headerName: "Route URN", width: 250, hide: !(rateCardDetails?.category === "Transporter" && rateCardDetails?.itemType === "Transportation Rate") },
        { field: 'totalQuantity', headerName: "Total Qty(in MT)", width: 100 },
        { field: 'committedQuantity', headerName: "Committed Qty(in MT)", width: 150 },
        { field: 'landName', headerName: LAND_NAME, width: 150, hide: !(rateCardDetails?.category === "Grower" && rateCardDetails?.itemType === "Bamboo Rate") },
        {
            field: 'validFrom', headerName: 'Valid From', width: 170,
            renderCell: (params) => {
                return (
                    <>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DesktopDatePicker
                                label="Valid From"
                                inputFormat="DD/MM/YYYY"
                                value={params.row?.validFrom}
                                onChange={(newValue) => handleEachChange(newValue, params.row, "validFromEach")}
                                renderInput={(params) => <TextField {...params}
                                    size="small" />}
                                sx={{ minWidth: 750 }}
                            /></LocalizationProvider>
                    </>
                )
            }
        },
        {
            field: 'validTo', headerName: 'Valid To', width: 170,
            renderCell: (params) => {
                return (
                    <>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DesktopDatePicker
                                label="Valid To"
                                inputFormat="DD/MM/YYYY"
                                minDate={params.row?.validFrom}
                                value={params?.row?.validTo}
                                onChange={(newValue) => handleEachChange(newValue, params.row, "validToEach")}
                                renderInput={(params) => <TextField {...params}
                                    size="small" />}
                                sx={{ minWidth: 750 }}
                            /></LocalizationProvider>
                    </>
                )
            }
        },
        {
            field: 'expiredDate', headerName: 'Expiry Date', width: 170,
            renderCell: (params) => {
                return (
                    <>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DesktopDatePicker
                                label="Expiry Date"
                                inputFormat="DD/MM/YYYY"
                                value={params.row?.expiredDate}
                                onChange={(newValue) => handleEachChange(newValue, params.row, "expiredDate")}
                                renderInput={(params) => <TextField {...params}
                                    size="small" />}
                                sx={{ minWidth: 750 }}
                            /></LocalizationProvider>
                    </>
                )
            }
        },
        {
            field: 'itemRate', headerName: ITEM_RATE, width: 150,
            renderCell: (params) => {
                return (
                    <TextField fullWidth
                        size="small"
                        label="Item Rate"
                        type="number"
                        onFocus={handleNumberFieldFocus}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '-' || evt.key === '+') && evt.preventDefault()}
                        value={params.row?.itemRate || ''}
                        onChange={(e) => handleEachChange(e, params.row, "itemRateEach")}
                    ></TextField>
                )
            }
        },
    ];
console.log("addedRateCardDetailsArr", addedRateCardDetailsArr)
    function addRateConfirmation() {
        loaderService.showLoader();
        apiClient
            .post(
                ADD_RATE_CONFIRMATION,
                addedRateCardDetailsArr.map(item => ({
                    ...item, comment: comment, createdByName: localStorage.getItem('userName'), rateMasterDocs: documentsArr.map((docItem) => ({
                        containerName: "resourcefiles",
                        documentGuid: docItem?.blobFileName,
                        documentName: docItem?.fileName
                    }))
                })),
                {
                    headers: {
                        Authorization: "Bearer " + getLocalStorageItem('id_token'),
                    },
                },
                null
            )
            .then((response) => {
                loaderService.hideLoader();
                if (response.data.status == "SUCCESS") {
                    toast.success(response.data.description);
                    setRateCardDetails({
                        ...rateCardDetails,
                        itemType: null,
                        itemRate: null,
                        // validFromProceed: null,
                        // validToProceed: null,
                        validFrom: null,
                        validTo: null,
                        expiredDate: null,
                        unitPer: null,
                        routeType: null,
                        state: null,
                        district: null,
                        revenueCircle: null
                    });
                    setRateCardDetailsArr([]);
                    setShowData(false);
                    setUrnsList();
                    setChooseDistrict([]);
                    setDocumentsArr([]);
                }
                else if (response.data.status == "FAILURE") {
                    toast.error(response.data.description)
                }
                else toast.error("Error! Please try again")
            })
            .catch(function (error) {
                loaderService.hideLoader();
                console.log(error);
            });
    }

    function rateCardValidity(finalRateCardDetailsArr, setCheckValidityResponse) {
        loaderService.showLoader();
        apiClient
            .post(CHECK_RATE_CARD_VALIDITY_STAKEHOLDER,
                finalRateCardDetailsArr?.map(({ totalQuantity, committedQuantity, ...item }) => item),
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setCheckValidityResponse(response.data);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log("apiClientERROR", error);
                loaderService.hideLoader();
            });
    }

    const handleSubmit = () => {
        if (!rateCardDetails?.unitPer) {
            setErrorMessage({ ...errorMessage, unitPerError: UNIT_PER_ERROR });
        }
        else if (finalRateCardDetailsArr?.length == 0) {
            toast.error("Please add item rate and then proceed")
        }
        else if (!comment) {
            setCommentError("Please add comment")
        }
        else {
            rateCardValidity(finalRateCardDetailsArr, setCheckValidityResponse)
        }
    }

    // const onConfirmSubmit = () => {
    //     handleLogModalClose();
    //     addRateConfirmation();
    // }

    const onConfirmSubmit = async () => {
        if (isApiCalled) return;
        setIsApiCalled(true);
        try {
            await addRateConfirmation();
            await new Promise((resolve) => setTimeout(resolve, 1000));
        } catch (error) {
            console.error("API failed:", error);
        } finally {
            setLogModalOpen(false);
            setIsApiCalled(false);
        }
    };

    const handleCheckboxChange = (selectedRowIds) => {
        setSelectedRows(selectedRowIds)
        setErrorMessage({ ...errorMessage, noSelectedPoError: "" })
    };

    // const onUploadCallBack = (docArray) => {
    //     setDocumentsArray(docArray);
    // }

    const onDeleteFile = (e, item) => {
        e.preventDefault();
        const rows = [...documentsArr];
        const index = rows.findIndex((doc) => doc === item);
        if (index !== -1) {
            rows.splice(index, 1);
            setDocumentsArr(rows);
        }
    };

    useEffect(() => {
        if (selectedFile) {
            getDocumentUploadDetails();
        }
    }, [selectedFile]);

    useEffect(() => {
        if (documentUploadDetails) {
            let tempARR = documentsArr ? [...documentsArr] : []
            documentUploadDetails?.blobResponse && tempARR.push(documentUploadDetails?.blobResponse);
            setDocumentsArr(tempARR);
        }
    }, [documentUploadDetails]);

    const uploadDocument = (e, type) => {
        if (allowedFileTypes.indexOf(e.target.files[0].type) < 0) {
            return;
        }
        if (e.target.files[0].size >= 5000000) {
            setFileuploadError('The file should be less than 5MB');
            setSelectedFile();
        }
        else if (e.target.files[0].name.split('.').length > 2) {
            setFileuploadError("Double extension file detected");
            setSelectedFile();
        }
        else if (fileNameValidation(e.target.files[0].name)) {
            setFileuploadError(FILE_NAME_VALIDATION_ERROR);
            setSelectedFile();
        }
        else {
            setSelectedFile(e.target.files[0]);
            setFileuploadError('');
        }
    };

    function getDocumentUploadDetails() {
        loaderService.showLoader();
        const formData = new FormData();
        formData.append("file", selectedFile);
        formData.append("fileName", selectedFile.name);
        formData.append("containerName", "resourcefiles");
        apiClient
            .post(
                UPLOAD_DCUMENT,
                formData,
                {
                    headers: {
                        AuthKey: authKey,
                    },
                }
            )
            .then((response) => {
                setDocumentUploadDetails(response.data);
                loaderService.hideLoader();
            })

            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
            });
    }

    return (
        <>
            <Grid container spacing={1}>
                <Grid item xs={12} lg={3}>
                    <TextField fullWidth disabled label="Category" value="Grower" />
                </Grid>
                <Grid item xs={12} lg={3}>
                    <TextField fullWidth disabled label="Item Type" value="Bamboo Rate" />
                </Grid>
            </Grid>
            <Grid container spacing={1} sx={{ mt: 1 }}>
                <>
                    <Grid item xs={12} lg={3}>
                        <FormControl sx={{ width: '100%', paddingRight: '3%' }} error={submit && !rateCardDetails?.state}>
                            <InputLabel id="mappedstakeholder-label">{STATE}</InputLabel>
                            <Select
                                label={STATE}
                                name="state" value={rateCardDetails?.state || ''} onChange={(e) => handleChange(e)}>
                                <MenuItem><em>{STATE}</em></MenuItem>
                                {
                                    chooseState?.map((statename) =>
                                        <MenuItem value={statename}>{statename && titleCase(statename)}</MenuItem>)
                                }
                            </Select>
                            <FormHelperText sx={{ color: 'red' }}>{errorMessage?.stateError}</FormHelperText>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} lg={3}>
                        <FormControl sx={{ width: '100%', paddingRight: '3%' }} error={submit && !rateCardDetails?.district}>
                            <InputLabel id="mappedstakeholder-label">{DISTRICT}</InputLabel>
                            <Select
                                label={DISTRICT}
                                name='district' value={rateCardDetails?.district || ''} onChange={(e) => handleChange(e)}>
                                <MenuItem><em>{DISTRICT}</em></MenuItem>
                                {
                                    chooseDistrict?.map((districtname) =>
                                        <MenuItem value={districtname}>{districtname && titleCase(districtname)}</MenuItem>)
                                }
                            </Select>
                            <FormHelperText sx={{ color: 'red' }}>{errorMessage?.districtError}</FormHelperText>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} lg={3}>
                        <FormControl sx={{ width: '100%', paddingRight: '3%' }}>
                            <InputLabel id="mappedstakeholder-label">{REVENUE_CIRCLE}</InputLabel>
                            <Select
                                label={REVENUE_CIRCLE}
                                name='revenueCircle' value={rateCardDetails?.revenueCircle || ''} onChange={(e) => handleChange(e)}>
                                <MenuItem><em>Select</em></MenuItem>
                                {
                                    chooseRevenueCircle?.map((revenueCirclename) =>
                                        <MenuItem value={revenueCirclename}>{titleCase(revenueCirclename)}</MenuItem>)
                                }
                            </Select>
                        </FormControl>
                    </Grid>
                </>
                <Grid item xs={12} lg={2}>
                    <Button endIcon={<ProceedIcon />} sx={{ minWidth: 100 }} className="RescProceed" variant="contained" onClick={onProceedViewRateCardTable}>{PROCEED}</Button></Grid>
            </Grid>
            <Grid container spacing={1} sx={{ mt: 1 }}>
                {showData &&
                    <>
                        <Grid item xs={12} lg={2}>
                            <FormControl sx={{ width: '100%', paddingRight: '3%' }}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DesktopDatePicker
                                        label="Valid From"
                                        inputFormat="DD/MM/YYYY"
                                        value={rateCardDetails?.validFrom}
                                        onChange={(validfromValue) => setRateCardDetails({ ...rateCardDetails, validFrom: validfromValue.format("YYYY-MM-DD") })}
                                        renderInput={(params) => <TextField {...params} />}
                                        sx={{ minWidth: 750 }}
                                    /></LocalizationProvider>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} lg={2}>
                            <FormControl sx={{ width: '100%', paddingRight: '3%' }}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DesktopDatePicker
                                        label="Valid To"
                                        inputFormat="DD/MM/YYYY"
                                        minDate={rateCardDetails?.validFrom}
                                        value={rateCardDetails?.validTo}
                                        onChange={(validtoValue) => setRateCardDetails({ ...rateCardDetails, validTo: validtoValue.format("YYYY-MM-DD") })}
                                        renderInput={(params) => <TextField {...params} />}
                                        sx={{ minWidth: 750 }}
                                    /></LocalizationProvider>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} lg={2}>
                            <FormControl sx={{ width: '100%', paddingRight: '3%' }}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DesktopDatePicker
                                        label="Expiry Date"
                                        inputFormat="DD/MM/YYYY"
                                        value={rateCardDetails?.expiredDate}
                                        onChange={(expiredDateValue) => setRateCardDetails({ ...rateCardDetails, expiredDate: expiredDateValue.format("YYYY-MM-DD") })}
                                        renderInput={(params) => <TextField {...params} />}
                                        sx={{ minWidth: 750 }}
                                    /></LocalizationProvider>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} lg={2}>
                            <TextField fullWidth
                                type="number"
                                label="Item Rate"
                                onFocus={handleNumberFieldFocus}
                                name="itemRate" value={rateCardDetails?.itemRate || ''} onChange={(e) => handleChange(e)}
                                onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '-' || evt.key === '+') && evt.preventDefault()}
                                sx={{ paddingRight: '3%' }}
                            />
                        </Grid>
                        <Grid item xs={12} lg={rateCardDetails?.category === "Transporter" ? 1 : 2}>
                            <div className="resource-common-label-heading">&nbsp;</div>
                            <p className="insert-button" onClick={(e) => onInsertItemRate(e)}>{INSERT_SELECTED}</p>
                        </Grid>

                        <Grid item xs={12} lg={3}>
                            <FormControl sx={{ width: '100%', paddingRight: '3%' }} error={submit && !rateCardDetails?.unitPer}>
                                <InputLabel id="selectstakeholder-label">{UNIT_PER}</InputLabel>
                                <Select
                                    label={UNIT_PER}
                                    name="unitPer" value={rateCardDetails?.unitPer || ''} onChange={(e) => handleChange(e)}>
                                    <MenuItem><em>{UNIT_PER}</em></MenuItem>
                                    {
                                        unitsList?.["unit per"]?.map((unitsList) =>
                                            <MenuItem value={unitsList}>{unitsList}</MenuItem>)
                                    }
                                </Select>
                                <FormHelperText sx={{ color: 'red' }}>{errorMessage?.unitPerError}</FormHelperText>
                            </FormControl>
                        </Grid>
                    </>}
            </Grid>
            {
                urnsList && showData ?
                    <Grid container spacing={1} sx={{ mt: 3 }}>
                        <Grid item xs={12} lg={12}>
                            <DataGrid autoHeight sx={{
                                height: 430, width: '100%', mt: 2,
                                '& .themeSuccess': {
                                    backgroundColor: '#FFFFFF'
                                },
                                '& .themeFailure': {
                                    backgroundColor: '#FF7F7F',
                                    color: '#1a3e72',
                                },
                                '& .themeNeutral': {
                                    backgroundColor: '#FFFFFF'
                                },
                            }}
                                rows={rateCardDetailsArr}
                                columns={columns}
                                pageSize={10}
                                checkboxSelection
                                onSelectionModelChange={handleCheckboxChange}
                                getCellClassName={(params) => {
                                    return failedRateCardArr?.includes(params?.row) ? 'themeFailure' : 'themeSuccess';
                                }}
                                components={{
                                    Toolbar: CustomDataGridToolbar,
                                }}
                                componentsProps={{ toolbar: { rows: rateCardDetailsArr, columns: excelColumns, fileName: "RateCard.xlsx", name: "Download Template" } }}
                            />
                        </Grid>
                        <div className='resource-common-error-message' >{errorMessage.addItemError}</div>
                        <Grid item xs={8} mt={2}>
                            <TextField fullWidth
                                inputProps={{
                                    maxLength: 1000,
                                }}
                                error={commentError}
                                helperText={commentError}
                                label="Comment"
                                multiline
                                value={comment} onChange={(e) => { setComment(VALIDATION.noSpecialCharacterValidation(e.target.value)); setCommentError(""); }}
                            />
                            <div style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: '1vh' }}>
                                <Badge bg={`${comment?.length > characterLimit ? 'danger' : 'primary'}`}>{comment?.length}/{characterLimit}</Badge>
                            </div>
                        </Grid>
                        <Grid item xs={12} lg={5}>
                            <div className='row-flex'>
                                <label className="view-file-link-common">
                                    <input
                                        style={{ display: "none" }}
                                        type="file"
                                        accept="image/jpeg, image/jpg, image/png, .pdf"
                                        name="photo"
                                        onChange={(e) => uploadDocument(e)}
                                    />Upload File
                                </label>
                                {documentsArr?.map((item, index) => {
                                    return (
                                        <div style={{ display: "flex", flexDirection: "row", marginLeft: '1vh' }} className='view-file-name-common'>
                                            {item?.fileName}
                                            <img src={TrashIcon} style={{ cursor: "pointer", marginLeft: "2vh", height: "3vh" }} alt="TrashIcon" onClick={(e) => onDeleteFile(e, item)} />
                                        </div>
                                    )
                                })}
                            </div>
                            <Typography style={{ marginLeft: "3vh" }} variant="subtitle2" fontSize="1.8vh" align="left" color="green">{t('preReg.uploadFileTypeNote')}</Typography>
                            <div className='resource-knowledge-error-message' >{fileuploadError}</div>
                        </Grid>
                    </Grid>
                    :
                    <></>
            }
            <Grid item xs={12} lg={12} display='flex' justifyContent="flex-end">
                {urnsList && showData &&
                    <Button endIcon={<SubmitIcon />} sx={{ minWidth: 100, mt: 2, ml: 2 }} variant="contained" value='add' onClick={handleSubmit}>Submit</Button>
                }
            </Grid>
            <DistrictChangePopover onOpen={distrcitLogModalOpen} onConfirm={onConfirmCallBack} onClose={onCancelBack} />
            <ConfirmationPopover onOpen={logModalOpen} onConfirm={onConfirmSubmit} onClose={handleLogModalClose} action="Submit" specialMessage={!checkValidityResponse?.every(item => item?.abrplRespStts?.status === "SUCCESS") ? "Items marked in red won't be submitted (i.e if there is an existing rate for the selected period)" : ""} />
        </>
    );
}
export default CreateAndSendRatesToStakeholders;
